import { IOptions } from '@suprsend/web-components';

export const SUPRSEND_CONFIG: IOptions = {
  publicApiKey: "SS.PUBK.dlcr6-_3N3OQT76yVLthwbxzAZCzxNzfPDKtNaOHBWM",
  userAuthenticationHandler: (response: any) => {
    console.log("User Authentication Response", response);
  },

  // Toast notification with dark mode
  toast: {
    position: "top-right",
    duration: 5000,
    hideAvatar: false,
    theme: {
      container: {
        backgroundColor: "#1e1e1e",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
      },
      headerText: {
        color: "#ffffff",
        fontWeight: "600",
      },
      bodyText: {
        color: "#e0e0e0",
        linkColor: "#60a5fa",
        blockquoteColor: "#9ca3af",
      },
      avatar: {
        border: "2px solid #374151",
      },
    },
  },

  // Inbox with dark mode theme
  inbox: {
    hideToast: false,
    theme: {
      // Bell icon customization
      bell: {
        color: "#e0e0e0",
        height: 24,
        width: 24,
      },
      // Badge customization
      badge: {
        backgroundColor: "#ef4444",
        color: "#ffffff",
      },
      // Header customization
      header: {
        container: {
          backgroundColor: "#1e1e1e",
          borderBottom: "1px solid #374151",
          padding: "16px",
        },
        headerText: {
          color: "#ffffff",
          fontSize: "18px",
          fontWeight: "600",
        },
        markAllReadText: {
          color: "#60a5fa",
          cursor: "pointer",
        },
      },
      // Tabs customization
      tabs: {
        color: "#60a5fa",
        unselectedColor: "#9ca3af",
        bottomColor: "#60a5fa",
        badgeColor: "#ef4444",
        badgeText: "#ffffff",
      },
      // Notifications container
      notificationsContainer: {
        container: {
          backgroundColor: "#1e1e1e",
          maxHeight: "400px",
          overflowY: "auto",
        },
        noNotificationsText: {
          color: "#9ca3af",
          fontSize: "16px",
        },
        noNotificationsSubtext: {
          color: "#6b7280",
          fontSize: "14px",
        },
        loader: {
          color: "#60a5fa",
        },
      },
      // Individual notification cards
      notification: {
        container: {
          backgroundColor: "#262626",
          readBackgroundColor: "#1e1e1e",
          unreadBackgroundColor: "#2d2d2d",
          hoverBackgroundColor: "#333333",
          borderBottom: "1px solid #374151",
          padding: "12px",
        },
        headerText: {
          color: "#ffffff",
          fontWeight: "600",
          fontSize: "14px",
        },
        bodyText: {
          color: "#e0e0e0",
          fontSize: "13px",
          linkColor: "#60a5fa",
          blockquoteColor: "#9ca3af",
          tableBorderColor: "#374151",
        },
        createdOnText: {
          color: "#9ca3af",
          fontSize: "12px",
        },
        unseenDot: {
          backgroundColor: "#60a5fa",
        },
        avatar: {
          border: "2px solid #374151",
        },
        pinnedIcon: {
          color: "#fbbf24",
          height: 16,
          width: 16,
        },
        pinnedText: {
          color: "#fbbf24",
          fontSize: "12px",
        },
        expiresText: {
          expiringBackgroundColor: "#7c2d12",
          expiringColor: "#fbbf24",
        },
        actions: [{
          container: {
            backgroundColor: "#374151",
            hoverBackgroundColor: "#4b5563",
            borderRadius: "6px",
            padding: "8px 12px",
          },
          text: {
            color: "#ffffff",
            fontSize: "13px",
          },
        }],
        actionsMenuIcon: {
          color: "#9ca3af",
          hoverBackgroundColor: "#374151",
          height: 20,
          width: 20,
        },
        actionsMenu: {
          backgroundColor: "#262626",
          border: "1px solid #374151",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
        },
        actionsMenuItem: {
          hoverBackgroundColor: "#374151",
          padding: "8px 12px",
        },
        actionsMenuItemIcon: {
          color: "#9ca3af",
          height: 16,
          width: 16,
        },
        actionsMenuItemText: {
          color: "#e0e0e0",
          fontSize: "13px",
        },
      },
    },
    // headerIconUrl: "/assets/images/custom-icon.png",
    // headerIconClickHandler: () => console.log("Header clicked"),
  },

  // Feed with dark mode theme
  feed: {
    hideToast: false,
    hideFeed: false,
    theme: {
      header: {
        container: {
          backgroundColor: "#1e1e1e",
          borderBottom: "1px solid #374151",
          padding: "16px",
        },
        headerText: {
          color: "#ffffff",
          fontSize: "18px",
          fontWeight: "600",
        },
        markAllReadText: {
          color: "#60a5fa",
          cursor: "pointer",
        },
      },
      tabs: {
        color: "#60a5fa",
        unselectedColor: "#9ca3af",
        bottomColor: "#60a5fa",
        badgeColor: "#ef4444",
        badgeText: "#ffffff",
      },
      notificationsContainer: {
        container: {
          backgroundColor: "#1e1e1e",
        },
        noNotificationsText: {
          color: "#9ca3af",
        },
        noNotificationsSubtext: {
          color: "#6b7280",
        },
        loader: {
          color: "#60a5fa",
        },
      },
      notification: {
        container: {
          backgroundColor: "#262626",
          readBackgroundColor: "#1e1e1e",
          unreadBackgroundColor: "#2d2d2d",
          hoverBackgroundColor: "#333333",
          borderBottom: "1px solid #374151",
        },
        headerText: {
          color: "#ffffff",
        },
        bodyText: {
          color: "#e0e0e0",
          linkColor: "#60a5fa",
        },
        createdOnText: {
          color: "#9ca3af",
        },
        unseenDot: {
          backgroundColor: "#60a5fa",
        },
      },
    },
  },

  // Global settings
  locale: "es",
  initOnLoad: true,
};